import * as api from 'dashboard/resources/tickets.api';
import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import template from './tickets-widget.html';

const mapStateToThis = ({ session }) => {
  const { retailer } = session;

  return {
    retailer,
  };
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state')
class TicketsWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.loadDataAsync(() => api.fetchTicketsData(retailerId));
  }
}

export default class TicketsWidgetComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&',
    };
    this.controller = TicketsWidgetController;
    this.template = template;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/tickets/tickets-widget-component.js